<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      rounded
      color="primary"
    ></v-progress-linear>
    <v-sheet
      v-else 
      class="mx-auto slide-avatar"
    >
      <v-slide-group show-arrows>
        <v-slide-item
          v-for="firmante in this.value"
          :key="firmante.idFirmante"
          v-slot:default="{ active }"
        >
          <signer-avatar
            :signer="firmante"
            :status="status"
            :input-value="active"
            :last="isLastSinger"
            @deleted="signerDeleted"
          ></signer-avatar>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import SignerAvatar from '@/modules/signers/components/SignerAvatar'
import SignerService from '@/modules/signers/services/SignerService'
import { signerOrder } from '../../store/documentsUtils'

export default {
  name: 'DocumentSigners',
  components: {
    SignerAvatar
  },
  props: {
    value: {
      type: Array
    },
    idDocumento: {
      type: String
    },
    status: {
      type: Object
    }
  },
  computed:{
     isLastSinger(){
      let list = this.value.filter(s => !s.firmado)
        return list.length == 1
        }
  },
  data(){
    return {
      loading: false
    }
  },
  created(){
    this.loading = true
    let signerService = new SignerService();

    signerService.getSignersByDocumentId(this.idDocumento)
    .then((resolve)=>{
      let _signers = signerOrder(resolve.data)
      this.$emit('input', _signers)
    })
    .catch(()=>{
      this.$emit('input', [])
    })
    .finally(() => {
      this.loading = false
    }) 
  },
  methods: {
    signerDeleted(signer) {
      let newList = this.value.filter(s => {
        return s.id != signer.id
      })
      this.$emit('input', newList)
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-avatar {
  background-color: transparent !important;
  max-width: 212px;
}
</style>